import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from '../SearchResults.scss';
import mobileStyles from '../SearchResultsMobile.scss';
import Media from 'react-responsive';
import FilterBar from './FilterBar';
import Results from './Results';
import Analogs from './Analogs';
import ProductTable from './ProductTable';

const chosenBtn ={
  backgroundColor:'#7ab539',
  color: 'white'
};

export default class SearchInfoMobile extends Component {
  constructor(props, context) {
    super(props, context);
  }

  state = {
    isAnalogs: false
  };

  showAnalogs = () =>
    this.setState({
      isAnalogs: true
    });
  render() {
    return (
      <div className={mobileStyles.main_container}>
        <div>
          <div className={mobileStyles.button_group}>
            <button
              style={(!this.state.isAnalogs)? chosenBtn : {}}
              className={mobileStyles.left_btn}
              onClick={this.showAnalogs}>
                Искомый артикул
            </button>
            <button
              style={(this.state.isAnalogs)? chosenBtn : {}}
              className={mobileStyles.right_btn}
              onClick={this.showAnalogs}>
                Аналоги
            </button>
          </div>

          {!this.state.isAnalogs?
            <div>
              <ProductTable openToCartPopup={this.props.openToCartPopup} />
                <hr />
            </div>
            :
            <div>
              <ProductTable openToCartPopup={this.props.openToCartPopup} />
              <ProductTable openToCartPopup={this.props.openToCartPopup} />
            </div>
          }
        </div>
      </div>
    );
  }
}


SearchInfoMobile.propTypes = {
  openToCartPopup: PropTypes.func
};



/** WEBPACK FOOTER **
 ** ./src/components/SearchResults/elements/SearchInfoMobile.jsx
 **/